// @ts-nocheck
import { createAsyncActionTypes } from '../../../core/store/actionCreators';

export const FETCH_VOUCHER = 'voucher/fetchVoucher';
export const {
  pending: FETCH_VOUCHER_PENDING,
  fulfilled: FETCH_VOUCHER_FULFILLED,
  rejected: FETCH_VOUCHER_REJECTED,
} = createAsyncActionTypes(FETCH_VOUCHER);

export const DESELECT_VOUCHER = 'voucher/deselectVoucher';
